/**
 * @desc 查找门店
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** filter[location] */
  'filter[location]'?: string;
  /** lat */
  lat?: number;
  /** limit */
  limit: number;
  /** lng */
  lng?: number;
  /** store_type */
  store_type?: number;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<
    defs.store.GeneralHttpResponse<Array<defs.store.SimpleStoreVO>>
  >(`/storeapi/api/v1/store`, {
    params,
    method: 'get',
    ...(config || {}),
  });
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<Array<defs.store.SimpleStoreVO>>;
export default req;
